import { createApp } from "vue";
import { createPinia } from "pinia";
import "./styles/style.css";
import router from "./routes/routes";
import App from "./App.vue";
import * as Sentry from "@sentry/vue";

const pinia = createPinia();

pinia.use(Sentry.createSentryPiniaPlugin());

const app = createApp(App);
if (
  ["production", "development"].includes(process.env.VUE_APP_SENTRY_ENV ?? "")
) {
  Sentry.init({
    environment: process.env.VUE_APP_SENTRY_ENV,
    app,
    dsn: "https://a4f9c1a7463eaa1aad282deb222cc250@o4508677213257728.ingest.us.sentry.io/4508677470289920",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      // Disable input masking so that form data (and visible fonts/text) is captured
      Sentry.replayIntegration({
        maskAllInputs: false, // <-- Set to false to show input content
        // You can also adjust other options if needed, e.g., blockAllMedia, etc.
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  console.log("sentry integrated successfully");
}

app.use(pinia).use(router).mount("#app");
